export const ROLES = {
  CLIENT: 'client',
  EXPERT: 'expert',
  SPECIALIST: 'specialist',
  MENTOR: 'mentor',
  MASTER: 'master',
  FOUNDER: 'founder',
  HELPER: 'helper',
  AGENT: 'agent',
  BUYER: 'buyer',
};
